export enum TextTemplateTypeEnum {
  AutoText = 1,
  FeeSheetInstructions = 2,
  FeeSheetEmail = 3,
  AnalysisReport = 4,
  AuditorReport = 5,
  RespondToAgent = 6,
  ForwardToClient = 7
}